import feature from '../constants/analytics/categoryActionLabel/feature';
import { errorLabels } from '../constants/interestSelector';
import { logInterestSelectorAction } from './logging';

export const UPDATE_INTEREST_SELECTOR_ITEMS = 'UPDATE_INTEREST_SELECTOR_ITEMS';

export function updateInterestSelectorItems(
  guideIds = [],
  classifierLabel,
  removeInterests = false,
) {
  return async (dispatch) => {
    try {
      await dispatch({
        type: UPDATE_INTEREST_SELECTOR_ITEMS,
        api: {
          endpoint: ['user', 'updateInterests'],
          args: [{ guideIds, removeInterests }],
        },
      });

      dispatch(
        logInterestSelectorAction(
          removeInterests ? feature.labels.remove : feature.labels.save,
          classifierLabel,
          guideIds,
        ),
      );
    } catch {
      const errorLabel = removeInterests
        ? errorLabels.errorBulkAddingInterests
        : errorLabels.errorBulkRemovingInterests;
      dispatch(logInterestSelectorAction(feature.labels.error, classifierLabel, errorLabel));
    }
  };
}
